<template>
  <div class="app-video">
    <video id=”media” :src="vUrl" controls></video>
  </div>
</template>

<script>

export default {
  name: 'NewAppVideo',
  data() {
    return {
      vId: '', //视频名称
      vUrl: '',
      vm: '', //视频模块
    }
  },
  mounted() {
    this.vId =  this.$route.params.vId
    this.vm =  this.$route.params.vm || 'vm'
    this.vUrl = this.getVideoObj()
  },
  methods: {
    getVideoObj() {
      const id = this.vId
      return 'http://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/app/prd/video/'+this.vm+'/'+id+'.mp4'
    },
  },
}
</script>

<style scoped>
.app-video video {
  height: 100vh;
  width: 100%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/NewAppVideo.vue